SidebarForm.$inject = ["$http", "$timeout", "$log", "UniConfig"];
// @ts-nocheck
import { $uniUP } from "../..";
function SidebarForm($http, $timeout, $log, UniConfig) {
  return {
    restrict: "E",
    scope: {
      visible: "=",
      title: "@",
      open: "@"
    },
    // controllerAs : 'gestionCtrl',
    // templateUrl : baseUrl + '/app/templates/vigilancia/progTrabajadoresModal.html',
    transclude: true,
    template: require("./sidebar-form.inline.html"),
    link: function link(scope, element, attrs, ctrls) {
      $log.debug("Instanciando sidebarform", scope);
      scope.$watch(function () {
        return scope.visible;
      }, function (val) {
        $log.debug("Cambio visible ", val);
        if (val) $("body").addClass("opened");else $("body").removeClass("opened");
      });
      scope.cerrarSidebarForm = function () {
        scope.visible = false;
      };
    }
  };
}
SidebarForm.$inject = ["$http", "$timeout", "$log", "UniConfig"];
$uniUP.directive("upSidebarForm", SidebarForm);